import axios from '@api'

export default {
    getFieldCompanyList() {
        return axios.get(`api/management/fieldcompany/list`);
      },
    getFieldListById(fieldId) {
        return axios.get(`api/management/field/` + fieldId);
      }, 
    getFieldList(json) {
        return axios.post(`api/management/field/list`, JSON.stringify(json));
      },
    getddlFieldList () {
        return axios.get(`api/management/field/dropdown`);
      },
    deleteMasterField  (jsonField) {
        return axios.put('api/management/field/delete', jsonField)
      },
    saveMasterField(jsonField) {
        return axios.post(`api/management/field/save/`, jsonField);
      },
}